<h3 class="title">
    {{ mode === "create" ? "Nuevo Tipo de Orden" : "Editar Tipo de Orden" }}
</h3>

<div class="scroll-area">
    <form [formGroup]="form" class="form-horizontal">
        <!-- Primera fila: Nombre / Descripción -->
        <div class="row g2">
            <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="nombre" />
                <mat-error *ngIf="form.get('nombre')?.hasError('required')"
                    >Requerido</mat-error
                >
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Descripción</mat-label>
                <input matInput formControlName="descripcion" />
            </mat-form-field>
        </div>

        <!-- Segunda fila: Maximos y Activo -->
        <div class="row g4 center">
            <mat-form-field appearance="outline">
                <mat-label>Max. por mes</mat-label>
                <input matInput type="number" formControlName="maxPerMonth" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Max. total</mat-label>
                <input matInput type="number" formControlName="maxTotal" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Caducidad (horas)</mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="caducidadHoras"
                />
            </mat-form-field>

            <div class="toggle-wrap">
                <mat-slide-toggle formControlName="activo"
                    >Activo</mat-slide-toggle
                >
            </div>
        </div>

        <!-- Tercera fila: Sedes (chips + input con autocomplete por NOMBRE/ID) -->
        <div class="block">
            <div class="block-header">
                <h4 class="m0">Sedes</h4>

                <div class="inline-add">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Buscar sede</mat-label>
                        <input
                            matInput
                            [matAutocomplete]="sedesAuto"
                            [formControl]="form.get('sedeInput')"
                            (keyup.enter)="addSelectedSede()"
                            placeholder="Ej: SANTA FE"
                        />
                        <mat-autocomplete
                            #sedesAuto="matAutocomplete"
                            [displayWith]="displaySede"
                            (optionSelected)="
                                onSedeSelected($event.option.value)
                            "
                        >
                            <mat-option
                                *ngFor="let s of filteredSedes$ | async"
                                [value]="s"
                            >
                                {{ s.nombre }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <button
                        mat-stroked-button
                        class="btn-secondary"
                        type="button"
                        (click)="addSelectedSede()"
                    >
                        Agregar
                    </button>
                </div>
            </div>

            <!-- ÚNICA lista de chips (ya no va otra dentro de inline-add) -->
            <div class="chips">
                <span
                    class="chip"
                    *ngFor="let c of sedesFA.controls; let i = index"
                >
                    {{ sedeName(c.value) }}
                    <button type="button" class="close" (click)="removeSede(i)">
                        ×
                    </button>
                </span>
                <span *ngIf="!sedesFA.length" class="muted"
                    >No hay sedes seleccionadas.</span
                >
            </div>
        </div>

        <!-- Cuarta fila: Ventanas (cada ventana en horizontal) -->
        <div class="block">
            <div class="block-header">
                <h4 class="m0">Ventanas</h4>
                <button
                    mat-stroked-button
                    class="btn-secondary"
                    type="button"
                    (click)="addVentana()"
                >
                    + Agregar ventana
                </button>
            </div>

            <div class="ventanas-list">
                <div
                    class="ventana-row"
                    *ngFor="let v of ventanasFA.controls; let i = index"
                    [formGroup]="v"
                >
                    <div class="days">
                        <label>Días</label>
                        <div class="day-btns">
                            <button
                                type="button"
                                *ngFor="let d of dayOptions"
                                (click)="toggleDay(i, d.value)"
                                [class.active]="v.value.days?.includes(d.value)"
                            >
                                {{ d.label }}
                            </button>
                        </div>
                    </div>
                    <div class="times">
                        <mat-form-field appearance="outline">
                            <mat-label>Inicio</mat-label>
                            <input
                                matInput
                                formControlName="start"
                                placeholder="HH:mm"
                                inputmode="numeric"
                            />
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Fin</mat-label>
                            <input
                                matInput
                                formControlName="end"
                                placeholder="HH:mm"
                                inputmode="numeric"
                            />
                        </mat-form-field>
                    </div>
                    <div class="v-actions">
                        <button
                            mat-button
                            color="warn"
                            type="button"
                            (click)="removeVentana(i)"
                        >
                            Eliminar
                        </button>
                    </div>
                </div>

                <div *ngIf="!ventanasFA.length" class="muted">
                    No hay ventanas configuradas.
                </div>
            </div>
        </div>

        <!-- Acciones -->
        <div class="actions">
            <button
                mat-stroked-button
                class="btn-secondary"
                type="button"
                (click)="cancel()"
            >
                Cancelar
            </button>
            <button
                mat-raised-button
                class="btn-primary"
                type="button"
                (click)="save()"
                [disabled]="guardando || form.invalid"
            >
                {{
                    guardando
                        ? "Guardando..."
                        : mode === "create"
                        ? "Crear"
                        : "Guardar"
                }}
            </button>
        </div>
    </form>
</div>
